module.exports = __webpack_public_path__ + "img/elburg-n3.09c5bd9b.jpg";